import {BaseContainerModel} from '../base-container.model';


export class EmailNotificationModel extends BaseContainerModel {
  sender = '';
  recipient =  [''];
  email_title =  '';
  email_body = '';
}
